// Images
import blackPink from "../../../media/images/black-pink1.jpg";
import levitating from "../../../media/images/levitating.png";
import senorita from "../../../media/images/senorita1.jpg";
import montero from "../../../media/images/montero1.png";
import nightChanges from "../../../media/images/night-changes1.png";
import money from "../../../media/images/money1.jpg";
import wdta from "../../../media/images/wdta.jpg";
import bts from "../../../media/images/bts1.jpg";
import hih from "../../../media/images/hih1.png";
import et from "../../../media/images/et.jpg";
import goblin from "../../../media/images/goblin.jpg";
import stuck from "../../../media/images/stuck.png";
import sts from "../../../media/images/sts.jpg";
import itr from "../../../media/images/itr.jpg";
import bt from "../../../media/images/bt.jpg";
import en from "../../../media/images/en.png";

// Audios
import senoritaAudio from "../../../media/audio/senorita.mp3";
import cmbynAudio from "../../../media/audio/cmbyn.mp3";
import moneyAudio from "../../../media/audio/money.mp3";
import butterAudio from "../../../media/audio/butter.mp3";
import hihAudio from "../../../media/audio/hih.mp3";
import ncAudio from "../../../media/audio/nc.mp3";
import wdtaAudio from "../../../media/audio/wdta.mp3";
import etAudio from "../../../media/audio/et.mp3";
import levitatingAudio from "../../../media/audio/levitating.mp3";
import hylt from "../../../media/audio/hylt.mp3";
import goblinAudio from "../../../media/audio/goblin.mp3";
import stuckAudio from "../../../media/audio/stuck.mp3";
import stsAudio from "../../../media/audio/sts.mp3";
import itrAudio from "../../../media/audio/itr.mp3";
import btAudio from "../../../media/audio/bt.mp3";
import enAudio from "../../../media/audio/en.mp3";

export const topSongsData = [
  {
    name: "How You Like That",
    artist: "Black Pink",
    duration: "3:28",
    img: blackPink,
    audio: hylt,
    color: "140, 30, 103",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/BLACKPINK%20-%20'How%20You%20Like%20That'%20M_V-ioNng23DkIM.mp4?alt=media&token=36c73c4b-e036-49ab-a342-bfeda81a1bb0",
  },
  {
    name: "Señorita",
    artist: "Shawn Mendes, Camila Cabello",
    duration: "3:11",
    img: senorita,
    audio: senoritaAudio,
    color: "73, 16, 22",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Shawn%20Mendes%2C%20Camila%20Cabello%20-%20Se%C3%B1orita%20(Official%20Music%20Video)-Pkh8UtuejGw.mp4?alt=media&token=9be484df-7ec4-4d77-9cad-54219a3b4cd3",
  },
  {
    name: "Call Me By Your Name",
    artist: "Lil Nas X MONTERO",
    duration: "3:09",
    img: montero,
    audio: cmbynAudio,
    color: "116, 1, 16",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Lil%20Nas%20X%20-%20MONTERO%20(Call%20Me%20By%20Your%20Name)%20(Official%20Video)-6swmTBVI83k.mp4?alt=media&token=b7775f23-8467-4fe2-9f56-637ca138cdfc",
  },
  {
    name: "Enchanted",
    artist: "Taylor Swift",
    duration: "5:52",
    img: en,
    audio: enAudio,
    color: "143, 56, 102",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Enchanted%20-%20Taylor%20Swift%20(Music%20Video)-m8hP9m-jDn8.mp4?alt=media&token=988afd8a-8671-47e5-8a44-9ed77fddfb21",
  },
  {
    name: "MONEY",
    artist: "LISA",
    duration: "2:46",
    img: money,
    audio: moneyAudio,
    color: "8, 42, 69",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/LISA%20-%20'MONEY'%20EXCLUSIVE%20PERFORMANCE%20VIDEO-dNCWe_6HAM8.mp4?alt=media&token=ede1d2b4-7791-4447-bb95-ed2cf7a584f4",
  },
  {
    name: "Butter",
    artist: "BTS",
    duration: "2:45",
    img: bts,
    audio: butterAudio,
    color: "141, 149, 0",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/BTS%20(%EB%B0%A9%ED%83%84%EC%86%8C%EB%85%84%EB%8B%A8)%20'Butter'%20Official%20MV-WMweEpGlu_U.mp4?alt=media&token=20f13faa-f2e4-48a1-bb19-a0072ae55c18",
  },
  {
    name: "Harleys In Hawaii",
    artist: "Katy Perry",
    duration: "3:05",
    img: hih,
    audio: hihAudio,
    color: "230, 152, 165",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Katy%20Perry%20-%20Harleys%20In%20Hawaii%20(Official)-sQEgklEwhSo.mp4?alt=media&token=7b92435e-ba92-4ff3-a320-86cf82b9c059",
  },
  {
    name: "Night Changes",
    artist: "One Direction",
    duration: "3:51",
    img: nightChanges,
    audio: ncAudio,
    color: "93, 61, 17",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/One%20Direction%20-%20Night%20Changes-syFZfO_wfMQ.mp4?alt=media&token=fef1922f-309b-45d1-a3dc-b35b79aac417",
  },
  {
    name: "We Don't Talk Anymore",
    artist: "Charlie Puth feat. Selena Gomez",
    duration: "3:37",
    img: wdta,
    audio: wdtaAudio,
    color: "4, 6, 77",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/wdta.mp4?alt=media&token=f8de19a1-fb15-4937-b594-00abfcaa9372",
  },
  {
    name: "18",
    artist: "One Direction",
    duration: "4:08",
    img: et,
    audio: etAudio,
    color: "9, 4, 2",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/One%20Direction%20-%2018%20%5BOfficial%20Video%5D-BtXqVROTiII.mp4?alt=media&token=e3e817e9-c911-44e7-bfa6-36f6e5e7c1b8",
  },
  {
    name: "Levitating",
    artist: "Dua Lipa Featuring DaBaby",
    duration: "3:50",
    img: levitating,
    audio: levitatingAudio,
    color: "2, 5, 6",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Dua%20Lipa%20-%20Levitating%20Featuring%20DaBaby%20(Official%20Music%20Video)-TUVcZfQe-Kw.mp4?alt=media&token=70869707-6abc-49a5-ba5d-48d9568235b1",
  },
  {
    name: "Stay with me",
    artist: "Goblin 도깨비 OST (Chanyeol, Punch)",
    duration: "3:15",
    img: goblin,
    audio: goblinAudio,
    color: "1, 55, 89",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Goblin%20%EB%8F%84%EA%B9%A8%EB%B9%84%20OST%20(Chanyeol%2C%20Punch)%20-%20Stay%20with%20me%20MV-wdHeiVf0mds.mp4?alt=media&token=872863cd-dc16-46be-a632-99c219225e4f",
  },
  {
    name: "Stuck with U",
    artist: "Ariana Grande, Justin Bieber",
    duration: "3:49",
    img: stuck,
    audio: stuckAudio,
    color: "6, 55, 11",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Ariana%20Grande%20%26%20Justin%20Bieber%20-%20Stuck%20with%20U-pE49WK-oNjU.mp4?alt=media&token=0028063c-790a-4a21-b60a-2cb6536fedfc",
  },
  {
    name: "Side To Side",
    artist: "Ariana Grande ft. Nicki Minaj",
    duration: "3:57",
    img: sts,
    audio: stsAudio,
    color: "11, 44, 66",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Ariana%20Grande%20ft.%20Nicki%20Minaj%20-%20Side%20To%20Side%20(Official%20Video)%20ft.%20Nicki%20Minaj-SXiSVQZLje8.mp4?alt=media&token=79683ab1-c988-40f7-9c85-9e5ad87ea994",
  },
  {
    name: "Into Your Arms",
    artist: "Witt Lowry feat. Ava Max",
    duration: "3:06",
    img: itr,
    audio: itrAudio,
    color: "99, 66, 22",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Witt%20Lowry%20-%20Into%20Your%20Arms%20(feat.%20Ava%20Max)%20(Official%20Music%20Video)-h3YXec5gJi0.mp4?alt=media&token=521be059-e7ab-4bee-8a59-3b2ae1c3ba2d",
  },
  {
    name: "Bad Things",
    artist: "Machine Gun Kelly, Camila Cabello",
    duration: "3:58",
    img: bt,
    audio: btAudio,
    color: "0, 44, 11",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Machine%20Gun%20Kelly%2C%20Camila%20Cabello%20-%20Bad%20Things%20(Official%20Music%20Video)-QpbQ4I3Eidg.mp4?alt=media&token=33004eef-c013-4055-9ab5-034140393208",
  },
];
